import React, { PureComponent, PropTypes } from 'react';
import Mediator from '../../services/Mediator';

class Cell extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {};
        this.input = null;
    }
    render() {
        let { handleKeyDown, id, index, required, onCellChange, value } = this.props;

        let className = 'cell' + (required && !value ? ' error' : '');

        return (<div className={className}>
            <input name={ `cell_${ id }_${ index }` } value={ value } onChange={ onCellChange } onKeyDown={ handleKeyDown } onFocus={ () => Mediator.broadcast('GridCellChange', index) } onBlur={ () => Mediator.broadcast('GridCellChange', null) } />
        </div>);
    }
}

Cell.propTypes = {
    handleKeyDown: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    onCellChange: PropTypes.func.isRequired,
    required: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired
};

export default Cell;


// WEBPACK FOOTER //
// ./src/components/deckeditor/cell.js